class ObjectHelper{

    /**
     * Inject a prototype as object in a class instance at specific prototype hierarchical level
     * @param classInstance instance, where inject the prototype
     * @param injectedPrototype object prototype to inject
     * @param prototypeInterface interface with class + prototype information
     */
    injectPrototype(classInstance:Object,injectedPrototype:Object,prototypeInterface:Function):void{
        let classInstanceWrapper = <any>classInstance;
        while (classInstanceWrapper && classInstanceWrapper.__proto__.constructor !== prototypeInterface) {
            classInstanceWrapper = classInstanceWrapper.__proto__;
        }
        classInstanceWrapper.__proto__ = injectedPrototype;
    }

    /**
     * Return class name of instance object (by http://stackoverflow.com/questions/332422/how-do-i-get-the-name-of-an-objects-type-in-javascript)
     * @param instance
     * @returns {T|string}
     */
    getClassNameOfInstance(instance:any):string{
        // extract the function name
        // adjusted upper referenced regex solution with this solution(https://stackoverflow.com/a/7124976)
        // because the regex before didn't worked for minified code
        var funcNameRegex = /function (.+?)\(/;
        var results = (funcNameRegex).exec(instance.toString());
        return (results && results.length > 1) ? results[1] : "";
    }

}

export default new ObjectHelper();


// WEBPACK FOOTER //
// ./src/app/utils/ObjectHelper.ts